import { catchError, map, switchMap, take } from 'rxjs/operators';
import { Observable, of, throwError } from 'rxjs';
import { UserService, User } from '@hub-services/user.service';
import { AuthRedirectInitiatedError } from './auth-redirect-initiated-error';
import {  Injectable } from '@angular/core';

import { RoleType } from '../admin/role-type.enum';
import { Router, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AdminAuthGuard  {

  private whitelistedRoles = [RoleType.ADMIN];

  constructor(
    private userService: UserService,
    private router: Router,
    private authService: AuthService,
  ) { }

  canActivate(): Observable<boolean | UrlTree> {
    return this.authService.waitForIdle().pipe(
      switchMap(() => this.userService.getUser().pipe(take(1))),
      map((user: User | null) => this.checkPermisions(user as User)),
      catchError((err: unknown) => {
        if (err instanceof AuthRedirectInitiatedError) {
          return of(false);
        }
        return throwError(() => err);
      })
    );
  }

  canActivateChild(): Observable<boolean | UrlTree> {
    return this.canActivate();
  }

  private checkPermisions(user: User): boolean | UrlTree {
    if (user && this.whitelistedRoles.includes(user.role)) {
      return true;
    }

    if (!user) {
      return this.router.createUrlTree(['/access-denied']);
    }

    if(user && user.role !== RoleType.OBSERVER) {
      return this.router.createUrlTree(['/upas/view']);
    }

    if(user && user.role === RoleType.OBSERVER) {
      return this.router.createUrlTree(['/observer/upas/category']);
    }

    return this.router.createUrlTree(['/access-denied']);
  }
}
